export enum ConditionType {
    VISIBILIDAD = 1
}
